export default __webpack_public_path__ + "static/1-5-3-0-783c83619725316e2a44f6bc6b4eeb25.jpg";